import styles from './Footer.module.scss';
import { FooterLinks } from '~/components/common/Footer/FooterLinks';
import { LogoAndRights } from '~/components/common/LogoAndRights';

type Props = {
  hasLinks?: boolean;
};

export const Footer = ({ hasLinks }: Props) => {
  return (
    <div className={styles.container}>
      {hasLinks && <FooterLinks className={styles['links']} />}
      <LogoAndRights />
    </div>
  );
};
